import USER_ROLES from "../../../constants/userRoles.constants";
import APPLICATION_EVENTS from "../../../constants/applicationEvents.constant";
import EVALUATION_STATUSES from "../../../constants/evaluationStatuses.constant";

class StepsListController {
    constructor(
        $rootScope,
        $scope,
        $stateParams,
        $state,
        $mdToast,
        evaluationService,
        userService
    ) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$mdToast = $mdToast;
        this.evaluationService = evaluationService;
        this.userService = userService;
        this.stateMode = $state.includes("mini") ? "mini" : "evaluation";
        this.evaluationId = $stateParams.id;
    }

    $onInit() {
        this.userService.loadCurrentUser().then(() => {
            this.isAdmin = this.userService.isInRole(USER_ROLES.ROLE_ADMIN);
            this.prepareSteps();
        });
    }

    gotoSelected(step) {
        if (step.clicked) {
            return;
        }
        if (
            step.destination &&
            this.evaluationService.currentEvaluation.status !==
                EVALUATION_STATUSES.NOT_STARTED
        ) {
            this.evaluationId = this.evaluationService.currentEvaluation.id;
            this.stepsList.forEach((stepEl) => {
                stepEl.clicked = false;
                stepEl.notified = false;
            });
            step.clicked = true;
            this.$state.go(step.destination, { id: this.evaluationId });
        } else if (
            !step.notified ||
            this.evaluationService.currentEvaluation.status ===
                EVALUATION_STATUSES.NOT_STARTED
        ) {
            this.$rootScope.$broadcast(
                APPLICATION_EVENTS.MARK_FORM_AS_SUBMITTED
            );
            step.notified = true;
            this.$mdToast.show(
                this.$mdToast
                    .simple()
                    .textContent(
                        "You need to fill required fields and click save before going to the next step."
                    )
                    .position("top center")
                    .action("Hide")
                    .highlightAction(true)
                    .hideDelay(5000)
                    .toastClass("error-toast")
            );
        }
    }

    prepareSteps() {
        if (this.evaluationId) {
            this.stepsList = [
                {
                    name: "Basic Information",
                    destination: `${this.stateMode}.basicInfo`,
                    step: `${this.stateMode}.basicInfo`,
                    clicked: this.$state.includes(
                        `${this.stateMode}.basicInfo`
                    ),
                },
                {
                    name: "Learning Goals",
                    destination: `${this.stateMode}.learningGoals.subjectArea`,
                    step: `${this.stateMode}.learningGoals`,
                    clicked: this.$state.includes(
                        `${this.stateMode}.learningGoals`
                    ),
                },
                {
                    name: "Pedagogical Approach",
                    destination:
                        this.stateMode !== "mini"
                            ? `${this.stateMode}.pedagogicalApproach.subjectArea`
                            : `${this.stateMode}.newMiniPedagogicalApproach`,
                    step:
                        this.stateMode === "mini"
                            ? "mini.newMiniPedagogicalApproach"
                            : `${this.stateMode}.pedagogicalApproach`,
                    clicked: this.$state.includes(
                        this.stateMode === "mini"
                            ? "mini.newMiniPedagogicalApproach"
                            : `${this.stateMode}.pedagogicalApproach`
                    ),
                },
                {
                    name: "Learning Engagement",
                    destination: `${this.stateMode}.learningEngagement.aspect`,
                    step: `${this.stateMode}.learningEngagement`,
                    clicked: this.$state.includes(
                        `${this.stateMode}.learningEngagement`
                    ),
                },
                {
                    name: "Conclusions",
                    destination: `${this.stateMode}.conclusions`,
                    step: `${this.stateMode}.conclusions`,
                    clicked: this.$state.includes(
                        `${this.stateMode}.conclusions`
                    ),
                },
            ];

            if (this.isAdmin) {
                this.stepsList.push({
                    name: "GDPR",
                    destination: `${this.stateMode}.gdpr`,
                    step: `${this.stateMode}.gdpr`,
                    clicked: this.$state.includes(`${this.stateMode}.gdpr`),
                });
            }
            if (this.isAdmin) {
                this.stepsList.push({
                    name: "Publish",
                    destination: `${this.stateMode}.publish`,
                    step: `${this.stateMode}.publish`,
                    clicked: this.$state.includes(`${this.stateMode}.publish`),
                });
            }
        } else {
            this.stepsList = [
                {
                    name: "Basic Information",
                    destination: `${this.stateMode}.basicInfo`,
                    step: `${this.stateMode}.basicInfo`,
                    clicked: this.$state.includes(
                        `${this.stateMode}.basicInfo`
                    ),
                },
                { name: "Learning Goals", notified: false },
                { name: "Pedagogical Approach", notified: false },
                { name: "Learning Engagement", notified: false },
                { name: "Conclusions", notified: false },
                { name: "GDPR", notified: false },
                { name: "Publish", notified: false },
            ];
        }
    }
}

StepsListController.$inject = [
    "$rootScope",
    "$scope",
    "$stateParams",
    "$state",
    "$mdToast",
    "EvaluationService",
    "UserService",
];

export default StepsListController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/stepsList/stepsListController.js